import "./application.css"
import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "../shopshift/components/App.jsx"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("shopshift-root")
  if (container) {
    const translations = JSON.parse(container.dataset.translations || "{}")
    const root = createRoot(container)
    root.render(
      <BrowserRouter>
        <App translations={translations} />
      </BrowserRouter>
    )
  }
})
